import Vue from "vue";
import Vuex from "vuex";
import Qs from 'qs';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      qureydata:Qs.parse(location.search.substring(1)),
      main:"#EF362B",
	  red:"#EC1122",
	  red_1:"#DA0A1B",
	  white:"#fff",
	  black:"#011133",
	  grey:"#ABABAB",
	  CDgrey:"#cdcdcd",
	  CCgrey:"#cccccc",
      grey_7:'#9799AB',
	  blue:"#3DA6F0",
	  blue_1:"#2878FF",
      blue_3:"#0055FF",//智能客服
      blue_4:"#0055ff17",//透明
	  green:"#4dd865",
      yellow:"#FEC22C",
	  yellow_2:"#F2991D",
      yellow_3:"#FF6600",
      iscode:1,
	  userdata:'',//个人信息
      userdatawl:'',//个人信息(物流)
	  loginstatus:'',//是否登录
      islogin:false,//登录窗口
	  configdata:'',//配置信息
      configdatawl:'',//配置信息(物流)
      maincatids:'',//机型配置
      positionObj:'',
      isDriver:false,
      isAdmin:false,
      isManager:false,
      sharePopup:false,
      modePopup:false,
      loginshow:false,//登录提示
      successPopup:false,
      customData:'',//客户详情
      draftData:'',//汇票详情
      attestationData:'',//认证提交数据
  },
  mutations: {
	  SET_USERDATA(state,userdata){ //个人信息
	  	state.userdata = userdata
	  },
      SET_ISCODE(state,iscode){ //个人信息
      	state.iscode = iscode
      },
      SET_USERDATAWl(state,userdatawl){ //个人信息(物流)
      	state.userdatawl = userdatawl
      },
	  SET_LOGINSTATUS(state,loginstatus) { //是否登录
	  	state.loginstatus=loginstatus
	  },
      SET_ISLOGIN(state,islogin){//登录窗口
        state.islogin=islogin;
      },
	  SET_CONFIGDATA(state,configdata){//配置信息
        state.configdata=configdata;
	  },
      SET_CONFIGDATAWL(state,configdatawl){//配置信息(物流)
        state.configdatawl=configdatawl;
      },
      SET_ISDRIVER(state,isDriver) { //是否司機
      	state.isDriver=isDriver
      },
      SET_ISADMIN(state,isAdmin){//是否货主
      state.isAdmin=isAdmin;
      },
      SET_ISMANAGER(state,isManager){//是否管理员
        state.isManager=isManager;
      },
      SET_SHAREPOPUP(state,sharePopup){//分享页面
        state.sharePopup=sharePopup;
      },
      SET_MODEPOPUP(state,modePopup){//
        state.modePopup=modePopup;
      },
      SET_MAINCATIDS(state,maincatids){//
        state.maincatids=maincatids;
      },
      SET_POSITIONOBJ(state,positionObj){//当前位置
        state.positionObj=positionObj;
      },
      SET_LOGINSHOW(state,loginshow){//登录提示
        state.loginshow=loginshow;
      },
      SET_SUCCESSPOPUP(state,successPopup){//上传完成确认提示
        state.successPopup=successPopup;
      },
      //数据处理customData
      SET_CUSTOMDATA(state,customData){//
        state.customData=customData;
      },
      SET_DRAFTDATA(state,draftData){//
        state.draftData=draftData;
      },
      SET_ATTESTATIONDATA(state,attestationData){//
        state.attestationData=attestationData;
      },
      
      
  },
  actions: {
	  set_userdata({ commit }, userdata) {//个人信息
	  	commit("SET_USERDATA", userdata)
	  },
      set_userdatawl({ commit }, userdatawl) {//个人信息
      	commit("SET_USERDATAWl", userdatawl)
      },
      set_iscode({ commit }, iscode) {//个人信息
      	commit("SET_ISCODE", iscode)
      },
	  set_loginstatus({ commit },loginstatus){//是否登录
	  	commit("SET_LOGINSTATUS",loginstatus)
	  },
      set_islogin({ commit },islogin){//登录窗口
      	commit("SET_ISLOGIN",islogin)
      },
	  set_configdata({ commit }, configdata) {//配置信息
	  	commit("SET_CONFIGDATA", configdata)
	  },
      set_configdatawl({ commit }, configdatawl) {//配置信息
      	commit("SET_CONFIGDATAWL", configdatawl)
      },
      set_isDriver({ commit }, isDriver) { //是否司機
      	commit("SET_ISDRIVER",isDriver)
      },
      set_isAdmin({ commit }, isAdmin) {//是否货主
        commit("SET_ISADMIN",isAdmin)
      },
      set_isManager({ commit }, isManager) {//是否管理员
        commit("SET_ISMANAGER",isManager)
      },
      set_sharePopup({ commit }, sharePopup) {//分享页面
        commit("SET_SHAREPOPUP",sharePopup)
      },
      set_modePopup({ commit }, modePopup) {//首页机型
        commit("SET_MODEPOPUP",modePopup)
      },
      set_maincatids({ commit }, maincatids) {//首页机型
        commit("SET_MAINCATIDS",maincatids)
      },
      set_positionObj({ commit }, positionObj) {//首页机型
        commit("SET_POSITIONOBJ",positionObj)
      },
      set_loginshow({ commit }, loginshow) {//登录提示
        commit("SET_LOGINSHOW",loginshow)
      },
      set_successPopup({ commit }, successPopup) {//上传完成确认提示
        commit("SET_SUCCESSPOPUP",successPopup)
      },
      //数据处理
      set_customData({ commit }, customData) {//首页机型
        commit("SET_CUSTOMDATA",customData)
      },
      set_draftData({ commit }, draftData) {//汇票数据
        commit("SET_DRAFTDATA",draftData)
      },
      set_attestationData({ commit }, attestationData) {//认证提交数据
        commit("SET_ATTESTATIONDATA",attestationData)
      }
  },
  modules: {}
});
